/* =============================================================================
 * build-a-box-cart-group.js — Agrupa visualmente, en la página /cart, las líneas
 * de carrito que pertenecen a un mismo ramillete armado con build-a-box en modo
 * "sumar por variedad" (ver assets/build-a-box.js, buildSumVariantsItems).
 *
 * Cada línea de un ramillete lleva las properties ocultas _bundle_id/_bundle_size
 * expuestas en el DOM de /cart como data-bundle-id/data-bundle-size (ver
 * sections/cart-template.liquid). Esta agrupación es puramente visual: Shopify
 * sigue manejando N líneas de carrito reales por separado (necesario para que el
 * cobro sea exacto); esto no afecta el cálculo de envío ni el Checkout nativo.
 *
 * BuildABoxCartGroup.run() se llama al cargar la página y de nuevo cada vez que
 * la tabla del carrito se vuelve a pintar por AJAX — ver el gancho agregado en
 * assets/theme.js (QtySelector.prototype.updateCartItemCallback). Es idempotente:
 * se puede llamar cualquier cantidad de veces seguidas sin duplicar encabezados.
 * =============================================================================
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, (window.theme && theme.moneyFormat) || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /** Deshace el agrupado de una corrida anterior, para poder volver a correr limpio. */
  function clearPreviousGrouping(tbody) {
    var headers = tbody.querySelectorAll('tr.build-a-box-group-header');
    for (var i = 0; i < headers.length; i++) {
      headers[i].parentNode.removeChild(headers[i]);
    }
    var rows = tbody.querySelectorAll('tr[data-bundle-id]:not([data-bundle-id=""])');
    for (var j = 0; j < rows.length; j++) {
      rows[j].classList.remove('build-a-box-group-row', 'build-a-box-group-row--last');
      var props = rows[j].querySelector('.cart-item__properties');
      if (props) props.classList.remove('build-a-box-group-hidden');
    }
  }

  /** Arma la fila de encabezado (imagen + título + tamaño + precio combinado) de un grupo. */
  function buildHeaderRow(groupRows, columnCount) {
    var firstRow = groupRows[0];
    var bundleSize = firstRow.getAttribute('data-bundle-size') || '';
    var img = firstRow.querySelector('img');
    var titleLink = firstRow.querySelector('a.h6, a.h5');
    var title = titleLink ? titleLink.textContent.trim() : '';
    var headerTitle = bundleSize ? (title + ' (' + bundleSize + ')') : title;

    var totalCents = 0;
    groupRows.forEach(function (row) {
      totalCents += parseInt(row.getAttribute('data-line-price') || '0', 10);
    });

    var headerRow = document.createElement('tr');
    headerRow.className = 'build-a-box-group-header';

    var td = document.createElement('td');
    td.colSpan = columnCount;

    var inner = document.createElement('div');
    inner.className = 'build-a-box-group-header__inner';

    if (img) {
      var imgClone = document.createElement('img');
      imgClone.src = img.getAttribute('src');
      imgClone.alt = '';
      imgClone.className = 'build-a-box-group-header__img';
      inner.appendChild(imgClone);
    }

    var titleSpan = document.createElement('span');
    titleSpan.className = 'build-a-box-group-header__title';
    titleSpan.textContent = headerTitle;
    inner.appendChild(titleSpan);

    var priceSpan = document.createElement('span');
    priceSpan.className = 'build-a-box-group-header__price';
    priceSpan.textContent = formatMoney(totalCents);
    inner.appendChild(priceSpan);

    td.appendChild(inner);
    headerRow.appendChild(td);
    return headerRow;
  }

  function run() {
    var tbody = document.getElementById('CartProducts');
    if (!tbody) return;

    clearPreviousGrouping(tbody);

    var columnCount = 4; // Product (colspan 2) + Quantity + Total, ver sections/cart-template.liquid
    var rows = Array.prototype.slice.call(
      tbody.querySelectorAll('tr[data-bundle-id]:not([data-bundle-id=""])')
    );
    var groups = {};
    var order = [];

    rows.forEach(function (row) {
      var bundleId = row.getAttribute('data-bundle-id');
      if (!groups[bundleId]) {
        groups[bundleId] = [];
        order.push(bundleId);
      }
      groups[bundleId].push(row);
    });

    order.forEach(function (bundleId) {
      var groupRows = groups[bundleId];
      if (groupRows.length < 2) return; // 1 sola línea no necesita encabezado

      groupRows.forEach(function (row) {
        row.classList.add('build-a-box-group-row');
        var props = row.querySelector('.cart-item__properties');
        if (props) props.classList.add('build-a-box-group-hidden');
      });
      groupRows[groupRows.length - 1].classList.add('build-a-box-group-row--last');

      var headerRow = buildHeaderRow(groupRows, columnCount);
      var firstRow = groupRows[0];
      firstRow.parentNode.insertBefore(headerRow, firstRow);
    });
  }

  window.BuildABoxCartGroup = { run: run };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
